'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _class, _temp, _initialiseProps;

var _AppEvents = require('./AppEvents');

var AppEvents = _interopRequireWildcard(_AppEvents);

var _Context = require('../Context');

var _UI = require('../UI');

var _Storage = require('../Storage');

var _WebAPI = require('../WebAPI');

var _DeskproWindow = require('../DeskproWindow');

var _Security = require('../Security');

var _Event = require('./Event');

var Event = _interopRequireWildcard(_Event);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A facade exposing all the underlying services required by an application
 *
 * @class
 */
var AppClient = (_temp = _class = function () {
  /**
   * @param {function} registerEventHandlers registers on demand event handlers via the {@link AppClient.subscribe} method
   * @param {AppEventEmitter} outgoingDispatcher the outgoing events dispatcher
   * @param {AppEventEmitter} incomingDispatcher the outgoing events dispatcher
   * @param {AppEventEmitter} internalDispatcher the internal events dispatcher
   * @param {InstanceProps} instanceProps the property bag containing instance props
   * @param {ContextProps} contextProps the property bag containing context props
   */
  function AppClient(_ref) {
    var registerEventHandlers = _ref.registerEventHandlers,
        outgoingDispatcher = _ref.outgoingDispatcher,
        incomingDispatcher = _ref.incomingDispatcher,
        internalDispatcher = _ref.internalDispatcher,
        instanceProps = _ref.instanceProps,
        contextProps = _ref.contextProps;
    (0, _classCallCheck3.default)(this, AppClient);

    _initialiseProps.call(this);

    var context = (0, _Context.createContext)(outgoingDispatcher, incomingDispatcher, instanceProps, contextProps);
    this.props = {
      registerEventHandlers: registerEventHandlers,
      outgoingDispatcher: outgoingDispatcher,
      incomingDispatcher: incomingDispatcher,
      internalDispatcher: internalDispatcher,
      instanceProps: instanceProps,
      contextProps: contextProps,
      context: context,
      restApi: (0, _WebAPI.createDeskproApiClient)(outgoingDispatcher),
      storageApi: (0, _Storage.createStorageAPIClient)(outgoingDispatcher, internalDispatcher, instanceProps, contextProps),
      deskproWindow: (0, _DeskproWindow.createDeskproWindowFacade)(outgoingDispatcher),
      oauth: (0, _Security.createOauthAPIClient)(outgoingDispatcher, internalDispatcher, instanceProps, contextProps),
      ui: (0, _UI.create)(outgoingDispatcher, internalDispatcher)
    };

    this._state = {
      isResizing: false,
      appTitle: instanceProps.appTitle,
      badgeCount: 0
    };
  }

  // EVENT EMITTER API
  // TODO this should not be made public since it is only intended for integrations with UI sdks like apps-react-sdk

  /**
   * Returns an instance of the internal event dispatcher
   *
   * @ignore
   * @public
   * @return {AppEventEmitter}
   */


  (0, _createClass3.default)(AppClient, [{
    key: 'subscribe',


    // EVENT SUBSCRIBER API

    /**
     * Get notified when the app receives an incoming event, such as one sent from the helpdesk window.
     * An example of such an event is the `context.ticket.reply`event which is sent when the agent replies to a ticket
     *
     * @param {string} eventName
     * @param {function(Object):Promise}  handler
     */
    value: function subscribe(eventName, handler) {
      var _this = this;

      var _props = this.props,
          outgoingDispatcher = _props.outgoingDispatcher,
          registerEventHandlers = _props.registerEventHandlers;


      function sendHandlerResponse(sendResponse, data) {
        var handlerResult = void 0;

        try {
          handlerResult = handler(data);
        } catch (e) {
          sendResponse(null, { canceled: false, message: e });
          return;
        }

        var handlerPromise = handlerResult instanceof _promise2.default ? handlerResult : _promise2.default.resolve(handlerResult);

        handlerPromise.catch(function (message) {
          sendResponse(null, { canceled: true, message: message });
          return _promise2.default.reject(message);
        }).then(function (message) {
          return sendResponse(null, { canceled: false, message: message });
        });
      }

      outgoingDispatcher.emitAsync(AppEvents.EVENT_SUBSCRIBE, { events: [eventName] }).then(function (events) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = (0, _getIterator3.default)(events), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var event = _step.value;

            var eventProps = { channelType: Event.CHANNEL_INCOMING, invocationType: event.invocationType };
            registerEventHandlers(_this, event.name, eventProps);
            _this.props.incomingDispatcher.on(event.name, sendHandlerResponse);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      });
    }

    /**
     * Triggers the listeners of an outgoing or internal event
     *
     * @public
     * @method
     * @param {string|{}} event
     * @param {...*} args
     * @return {Promise.<*>}
     */

  }, {
    key: 'emit',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(event) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        var outgoingDispatcher, internalDispatcher, dispatcherArgs;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(Event.isInvocation(event) && args.length > 0)) {
                  _context.next = 3;
                  break;
                }

                outgoingDispatcher = this.props.outgoingDispatcher;
                return _context.abrupt('return', outgoingDispatcher.emitInvokeAsync((0, _extends3.default)({}, event, { data: args[0] })));

              case 3:

                // internal event
                internalDispatcher = this.props.internalDispatcher;
                dispatcherArgs = [event].concat(args);

                internalDispatcher.emit.apply(internalDispatcher, dispatcherArgs);
                return _context.abrupt('return', _promise2.default.resolve(args));

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function emit(_x) {
        return _ref2.apply(this, arguments);
      }

      return emit;
    }()

    // Properties API

    /**
     * Returns the value of a property by looking up in the instance properties bag then in the context properties bag
     *
     * @public
     * @method
     * @param {String} propertyName
     * @return {String|null|undefined}
     */

  }, {
    key: 'eventDispatcher',
    get: function get() {
      return this.props.internalDispatcher;
    }

    /**
     * Registers an event listener. For the moment, you can only listen to internal events via this method
     *
     * @public
     * @param {String} eventName
     * @param {function} listener
     */


    /**
     * Removes an event listener. For the moment, only internal events are supported
     *
     * @public
     * @method
     * @param {String} eventName
     * @param {function} listener
     */


    /**
     * Adds a one time event listener for an internal event
     *
     * @public
     * @method
     * @param {String} eventName
     * @param {function} listener
     */

  }, {
    key: 'properties',


    /**
     * Returns a map of all the instance and context properties
     *
     * @public
     * @return {Object}
     */
    get: function get() {
      var _props2 = this.props,
          instanceProps = _props2.instanceProps,
          contextProps = _props2.contextProps;


      var instanceProperties = instanceProps.toJS();
      var contextProperties = contextProps.toJS();

      return (0, _extends3.default)({}, instanceProperties, contextProperties);
    }

    /**
     * Returns the name of the current application environment
     *
     * @public
     * @return {'production'|'development'}
     */

  }, {
    key: 'environment',
    get: function get() {
      var defaultEnvironment = 'production';

      var contextProps = this.props.contextProps;

      var env = contextProps.getProperty('appsEnvironment');
      return env || defaultEnvironment;
    }

    /**
     * The id of the application this instance belongs to
     *
     * @public
     * @readonly
     * @return {String}
     */

  }, {
    key: 'appId',
    get: function get() {
      return this.props.instanceProps.appId;
    }

    /**
     * The id of this instance
     *
     * @public
     * @readonly
     * @return {String}
     */

  }, {
    key: 'instanceId',
    get: function get() {
      return this.props.instanceProps.instanceId;
    }

    /**
     * The display title of this application
     *
     * @public
     * @return {String}
     */

  }, {
    key: 'appTitle',
    get: function get() {
      return this._state.appTitle;
    }

    /**
     * @ignore
     * @param {String} newTitle
     */
    ,
    set: function set(newTitle) {
      var oldTitle = this._state.appTitle;

      if (newTitle !== oldTitle) {
        this._state.appTitle = newTitle;

        var eventDispatcher = this.props.eventDispatcher;

        eventDispatcher.emit(AppEvents.EVENT_TITLE_CHANGED, newTitle, oldTitle);
      }
    }

    /**
     * Resets the display title of this application
     *
     * @public
     * @method
     */

  }, {
    key: 'packageName',


    /**
     * The package name (from package.json) of this application
     *
     * @public
     * @readonly
     * @type {String}
     */
    get: function get() {
      return this.props.instanceProps.appPackageName;
    }

    // Settings API

    /**
     * @public
     * @readonly
     * @type {Array}
     */

  }, {
    key: 'settings',
    get: function get() {
      return [];
    }

    // Misc API

    /**
     * Emits an internal event that signals its handlers the application needs to refresh. When the application has
     * an UI then it will re-render
     *
     * @public
     * @method
     */


    /**
     * Emits an internal event that signals its handlers the application initiated the unload process
     *
     * @internal
     * @method
     */

  }, {
    key: 'oauth',


    // CLIENTS

    /**
     * The oauth client
     *
     * @public
     * @readonly
     * @type {OauthFacade}
     */
    get: function get() {
      return this.props.oauth;
    }

    /**
     * The UI client of the application, which provides a standard way to invoke UI behaviour
     *
     * @public
     * @readonly
     * @type {UIFacade}
     */

  }, {
    key: 'ui',
    get: function get() {
      return this.props.ui;
    }

    /**
     * The help desk UI client, which enables interaction with the UI of the helpdesk window hosting the application
     *
     * @public
     * @readonly
     * @type {DeskproWindowFacade}
     */

  }, {
    key: 'deskproWindow',
    get: function get() {
      return this.props.deskproWindow;
    }
  }, {
    key: 'restApi',


    /**
     * A client for the Deskpro REST API
     *
     * @public
     * @readonly
     * @type {DeskproAPIClient}
     */
    get: function get() {
      return this.props.restApi;
    }
  }, {
    key: 'state',


    /**
     * @deprecated
     * 
     * @internal
     * @ignore
     * @type {StorageApiFacade}
     */
    get: function get() {
      return this.props.storageApi;
    }
  }, {
    key: 'storage',


    /**
     * A client for accessing the storage APIs in a simple manner
     *
     * @public
     * @readonly
     * @type {StorageApiFacade}
     */
    get: function get() {
      return this.props.storageApi;
    }
  }, {
    key: 'context',


    /**
     * The context in which the application runs
     *
     * @public
     * @readonly
     * @type {Context}
     */
    get: function get() {
      return this.props.context;
    }
  }]);
  return AppClient;
}(), _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.on = function (eventName, listener) {
    // TODO need to check if eventName is an internal one, for now just assume everyything is
    _this2.eventDispatcher.on(eventName, listener);
  };

  this.off = function (eventName, listener) {
    // TODO need to check if eventName is an internal one, for now just assume everything is
    _this2.eventDispatcher.removeListener(eventName, listener);
  };

  this.once = function (eventName, listener) {
    // TODO need to check if eventName is an internal one, for now just assume everything is
    _this2.eventDispatcher.once(eventName, listener);
  };

  this.getProperty = function (propertyName) {
    var _props3 = _this2.props,
        instanceProps = _props3.instanceProps,
        contextProps = _props3.contextProps;

    var value = instanceProps.getProperty(propertyName);

    if (value === undefined) {
      value = contextProps.getProperty(propertyName);
    }

    return value;
  };

  this.resetAppTitle = function () {
    _this2.appTitle = _this2.props.instanceProps.appTitle;
  };

  this.refresh = function () {
    var eventDispatcher = _this2.props.internalDispatcher;

    eventDispatcher.emit(AppEvents.EVENT_REFRESH);
  };

  this.unload = function () {
    var eventDispatcher = _this2.props.internalDispatcher;

    eventDispatcher.emit(AppEvents.EVENT_UNLOAD);
  };

  this.log = function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    console.log.apply(console, args);
  };
}, _temp);
exports.default = AppClient;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-sdk-core/lib/main/javascript/Core/AppClient.js
// module id = 164
// module chunks = 0